import '@/lib/browserCompatibility';
import '@/lib/displayLanguage';
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/mobile-ergonomie.css";
import App from "@/App";
import { AppErrorBoundary } from '@/components/AppErrorBoundary';

// Iter 420 : demande le stockage persistant (empeche l'OS mobile d'effacer
// le localStorage/token de la PWA quand il libere de l'espace)
if (navigator.storage && navigator.storage.persist) {
  navigator.storage.persist().catch(() => {});
}

if ('serviceWorker' in navigator) {
  // clients.claim() also changes controller on first install. Reloading then
  // destroys an in-progress form even though this page already has fresh JS.
  const hadControllerAtStartup = !!navigator.serviceWorker.controller;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Check for SW updates every 60s and on every focus
      const checkUpdate = () => reg.update().catch(() => {});
      setInterval(checkUpdate, 60000);
      window.addEventListener('focus', checkUpdate);

      // When a new SW is installed and waiting, activate it immediately
      // and reload the page so the user gets the new bundle without
      // having to manually clear the cache.
      reg.addEventListener('updatefound', () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener('statechange', () => {
          if (nw.state === 'installed' && navigator.serviceWorker.controller) {
            // A new SW is ready. Tell it to skip waiting then reload.
            try { nw.postMessage({ type: 'SKIP_WAITING' }); } catch { /* ignore */ }
          }
        });
      });

      // When the controller changes, reload once to pick up the new bundle
      let reloaded = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloaded || !hadControllerAtStartup) return;
        reloaded = true;
        window.location.reload();
      });
    }).catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary><App /></AppErrorBoundary>
  </React.StrictMode>,
);
